<div class="cancel-dialog-container">
  <h1 class="flex-fill" mat-dialog-title>{{titleText}}</h1>
  <mat-dialog-content [formGroup]="cancelForm" #formDirective="ngForm">
    <div class="flex-lg-column">
      <mat-form-field>
        <mat-label>Fecha</mat-label>
        <input matInput class="mat-input-element" [matDatepicker]="fecha" [formControl]="fechaControl" required>
        <mat-hint [hidden]="isReadOnly">DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="fecha" disabled></mat-datepicker-toggle>
        <mat-datepicker #fecha></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="flex-lg-column">
      <mat-form-field class="cancel-observacion">
        <mat-label>Observaciónes</mat-label>
        <input matInput #observacionInput [maxLength]=100 [formControl]="observacionControl"
               placeholder="Observaciónes" name="cancelar-observaciones" autocomplete="off" required>
        <mat-hint align="end" [hidden]="isReadOnly">{{observacionInput.value.length || 0}}/100</mat-hint>
        <mat-error *ngIf="observacionControl.invalid">Aporte Observaciones</mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" class="buttons" type="button" (click)="confirm()" [hidden]="isReadOnly">
      Guardar
    </button>
    <button mat-raised-button color="accent" class="buttons" type="button" (click)="exit()">
      Salir
    </button>
  </mat-dialog-actions>
</div>
